import React from "react";
import { AppContext } from "../../../context/AppContext";
import { useContext } from "react";
import { IoMdLogOut } from "react-icons/io";
import noImgFallback from "../../../assets/images/noimg.webp";

const TopHeader = ({ tabName }) => {
  const role = localStorage.getItem("role");
  const profilePicture = localStorage.getItem("profilePicture");
  const name = localStorage.getItem("name");
  const { handleLogout } = useContext(AppContext);

  const noImg = noImgFallback;

  return (
    <div className="flex items-center justify-between mb-5">
      <h1 className="text-md font-semibold">{tabName}</h1>
      <div className="flex items-center gap-4">
        <img
          className="relative inline-block h-10 w-10 !rounded-full  object-cover object-center"
          src={profilePicture || noImg}
          alt="Rounded avatar"
        />
        <div className="flex flex-col items-center text-sm">
          <p className="font-semibold">
            {role === "SUPER_ADMIN" ? "Hello Superadmin" : `Hello, ${name}`}
          </p>

          <p
            className="text-xs flex items-center gap-1 text-red-500 cursor-pointer"
            onClick={handleLogout}
          >
            <IoMdLogOut /> Sign Out
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
